import { plainText } from './Inline'
import type { DocBlock, DocSection } from './types'

function blockText(block: DocBlock): string {
  switch (block.type) {
    case 'p':
    case 'h':
      return block.text
    case 'list':
      return block.items.join(' ')
    case 'kv':
      return block.rows.flat().join(' ')
    case 'table':
      return [...block.head, ...block.rows.flat()].join(' ')
    case 'callout':
      return [block.title ?? '', block.text ?? '', ...(block.items ?? [])].join(' ')
    case 'live':
      return ''
  }
}

function normalise(value: string): string {
  return value.toLowerCase().normalize('NFKD').replace(/\p{M}/gu, '')
}

export interface SectionMatch {
  section: DocSection
  /** True when the title, summary or keywords match, not only the body. */
  inTitle: boolean
}

/**
 * Filter sections by every word of `query` (title, summary, keywords and body text), keeping
 * the handbook order. An empty query returns every section.
 */
export function filterSections(sections: readonly DocSection[], query: string): SectionMatch[] {
  const words = normalise(query).split(/\s+/).filter(Boolean)
  if (words.length === 0) return sections.map((section) => ({ section, inTitle: true }))
  const matches: SectionMatch[] = []
  for (const section of sections) {
    const head = normalise([section.title, section.summary, ...(section.keywords ?? [])].join(' '))
    const body = normalise(plainText(section.blocks.map(blockText).join(' ')))
    if (words.every((word) => head.includes(word))) matches.push({ section, inTitle: true })
    else if (words.every((word) => head.includes(word) || body.includes(word))) {
      matches.push({ section, inTitle: false })
    }
  }
  return matches
}
